/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsDelete } from "../../funcs/authTeamsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteTeamRequest$inboundSchema,
};

export const tool$authTeamsDelete: ToolDefinition<typeof args> = {
  name: "auth-teams-delete",
  description: `Delete a team`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
